import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ErrorComponent } from 'error-ui';

import { ProductComponentBase } from '../../../ProductComponentBase';
import { ProductAlternatesViewComponent } from './views/product-alternates-view';

@Component({
  selector: 'ideal-product-alternates',
  imports: [ProductAlternatesViewComponent, ErrorComponent],
  standalone: true,
  templateUrl: './product-alternates.component.html',
  styleUrls: ['./product-alternates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.loading]': 'loading()',
    '[class.no-content]': '!hasContent()',
  },
})
export class ProductAlternatesComponent extends ProductComponentBase {
  protected readonly alternates = this.productStore.productAlternates;
  protected readonly alternateItems = computed(() => this.alternates().filter((a): a is NonNullable<typeof a> => a != null));

  protected override readonly computeIsLoading = () => this.alternates.loading;
  protected override readonly computeHasContent = () => computed(() => !!this.alternates.error() || this.alternates().length > 0);
}
